import { Fragment } from "react"
import { Col, Row } from "reactstrap"

const VideoTop = props => {
  return (
    <Fragment>
      <Row className="bg-black">
        <Col md={{ offset: 2, size: 6 }}>
          <iframe
            src="https://share.synthesia.io/embeds/videos/957000b4-185f-4105-a5a2-d217e2cd39a6"
            loading="lazy"
            title="Synthesia video player - Editorial Enero 2024"
            allow="encrypted-media; fullscreen;"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              border: "none",
              padding: 0,
              margin: 0,
              overflow: "hidden",
            }}
          ></iframe>
        </Col>
        <Col md={4}>
          <p className="text-white paragraph">
            La nueva plataforma web revoluciona la forma en que interactuamos en
            línea, fusionando la innovación y accesibilidad. Su diseño intuitivo
            y características avanzadas prometen redefinir las expectativas de
            los usuarios en el mundo digital
          </p>
          <div className="call-to-action">
            <button className=" btn btn-block btn-secondary pt-2">
              <i className="fa fa-play-circle"></i> Reproducir
            </button>
            <div className="d-flex justify-content-end mt-4">
              <button className="btn btn-rounded btn-secondary pt-2 pl-4 pr-4">
                <i className="fa fa-heart"></i> 5.3k
              </button>
            </div>
          </div>
        </Col>
      </Row>
      <style jsx>{`
        .bg-black {
          background-color: #000000;
          height: 460px;
        }
        .paragraph {
          padding-top: 64px;
          padding-left: 64px;
          padding-right: 64px;
          font-size: 18px;
          color: #f6f6f6;
        }
        .call-to-action {
          padding-top: 32px;
          padding-left: 64px;
          padding-right: 64px;
        }
      `}</style>
    </Fragment>
  )
}

export default VideoTop
